import {
  ControlRow,
  ControlButton,
  ControlIcon,
  ControlLabel,
} from './chartControlStyles';

// Overlaid on the chart rather than placed under it: GraphMain is a fixed
// 488px column with roughly 13px of slack, so a control row would not fit
// without shrinking the chart or growing every ancestor.
const ChartScaleControls = ({
  scale,
  canScaleIn,
  canScaleOut,
  onScaleIn,
  onScaleOut,
}) => (
  <ControlRow>
    <ControlButton
      type='button'
      aria-label='scale out'
      onClick={onScaleOut}
      disabled={!canScaleOut}
    >
      <ControlIcon src='/images/zoomButtonMinus.svg' alt='' />
    </ControlButton>
    <ControlLabel>scale {scale}x</ControlLabel>
    <ControlButton
      type='button'
      aria-label='scale in'
      onClick={onScaleIn}
      disabled={!canScaleIn}
    >
      <ControlIcon src='/images/zoomButtonPlus.svg' alt='' />
    </ControlButton>
  </ControlRow>
);

export default ChartScaleControls;
